import { createElement } from 'react';
/**
 * This function wraps the component with necessary contexts and props for server-side rendering and client-side hydration.
 * It generates the rendering object and applies the required wrappers.
 */
export const WrapComponent = async (scene, renderData, wrappers) => {
    const Component = await scene.promisedComponent();
    const wrappedComponent = wrappers.reduce((componentSoFar, { wrapper, additionalWrapperArguments }) => {
        return wrapper(componentSoFar, additionalWrapperArguments);
    }, () => createElement(Component.default, renderData.props));
    return wrappedComponent;
};
